module.exports = {"230604001":"龙岗街道","230604002":"银浪街道","230604004":"奋斗街道","230604005":"庆新街道","230604007":"西宾街道","230604009":"乘风街道","230604010":"旭园街道","230604011":"北湖街道","230604012":"怡园街道","230604013":"东湖街道","230604014":"创业城街道","230604101":"喇嘛甸镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230604.json
// module id = 822
// module chunks = 0